import Vue from 'vue';
import ApiService, { status } from '@/services/ApiService';

export default {
  login(inputs) {
    return ApiService().post('/auth', inputs);
  },
  pickStation(station) {
    return ApiService().patch('/pick-station/' + station);
  },
  ping(lastPing) {
    return ApiService().post('/ping', {lastPing}, true);
  },
};
